import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import {
  MissionLifecycleFragmentFragment,
  ClientMissionLifecycleFragmentFragment,
  MissionContractPayment,
} from "@/gql"
import PaymentsMilestone from "@/modules/Missions/components/PaymentMilestones/PaymentMilestones.vue"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMilestonePrintable',
  props: {
    mission: null,
    editable: { type: Boolean },
    refetchQueries: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment | ClientMissionLifecycleFragmentFragment
  editable?: boolean
  refetchQueries: RefetchQueryDescription
}



const contractPayments = computed(() => {
  return props.mission.missionContract?.missionContractPayments as MissionContractPayment[]
})

return { __sfc: true,props, contractPayments, PaymentsMilestone }
}

})